import { render, staticRenderFns } from "./reach-and-frequency-container.vue?vue&type=template&id=af1bf65c&scoped=true"
import script from "./reach-and-frequency-container.vue?vue&type=script&lang=js"
export * from "./reach-and-frequency-container.vue?vue&type=script&lang=js"
import style0 from "./reach-and-frequency-container.vue?vue&type=style&index=0&id=af1bf65c&prod&lang=scss&scoped=true"
import style1 from "./reach-and-frequency-container.vue?vue&type=style&index=1&id=af1bf65c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1bf65c",
  null
  
)

export default component.exports